import { useState } from 'react'

import PlainModal, {
  PlainModalContent,
  PlainModalFooter,
  PlainModalHeader,
} from 'app/common/ui-next/plain-modal'

import PlainEditableProp from 'app/common/ui-next/plain-editable-prop'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'

import styles from './DishesTableEditableTitle.module.scss'

export const DishesTableEditableTitle = ({
  value,
  locked,
  onSubmit,
}: {
  value: string
  locked: boolean
  onSubmit: (value: string) => Promise<boolean>
}) => {
  const [newValue, setNewValue] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const showModal = (value: string) => {
    setNewValue(value)
  }

  const closeModal = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation()
    e?.preventDefault()
    setNewValue('')
  }

  const handleSubmit = async () => {
    setIsSubmitting(true)
    const res = await onSubmit(newValue)
    if (res) closeModal()
    setIsSubmitting(false)
  }

  if (locked) return <div>{value}</div>

  return (
    <>
      <PlainEditableProp value={value} onSubmit={showModal} multiline>
        {value}
      </PlainEditableProp>

      {!!newValue && (
        <PlainModal
          formId="dishes-table-editable-title-modal-confirm"
          className={styles.modal}
          onSubmit={handleSubmit}
          show
        >
          <PlainModalHeader onCrossClick={closeModal}>
            {'Изменить наименование продукции?'}
          </PlainModalHeader>

          <PlainModalContent>
            <span>{'Текущее наименование:'}</span>
            <ul>
              <li className={styles.oldName}>{value}</li>
            </ul>
            <span>{'Новое наименование:'}</span>
            <ul>
              <li className={styles.newName}>{newValue}</li>
            </ul>
          </PlainModalContent>

          <PlainModalFooter>
            <ControlsBar right>
              <PlainButton outline onClick={closeModal}>
                {'Отмена'}
              </PlainButton>
              <PlainButton type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Применяется...' : 'Применить'}
              </PlainButton>
            </ControlsBar>
          </PlainModalFooter>
        </PlainModal>
      )}
    </>
  )
}
